'use client';

import { useEffect, useState } from 'react';
import { fetchFeedbackConfig, type FeedbackCapabilities } from './api';

export const defaultFeedbackCapabilities: FeedbackCapabilities = {
  itsm: false,
  upvotes: true,
  editOwn: true,
  sortUpvotes: true,
};

export function useFeedbackCapabilities() {
  const [capabilities, setCapabilities] = useState<FeedbackCapabilities>(defaultFeedbackCapabilities);

  useEffect(() => {
    fetchFeedbackConfig()
      .then((res) => setCapabilities(res.capabilities))
      .catch(() => setCapabilities(defaultFeedbackCapabilities));
  }, []);

  return capabilities;
}
